import React from 'react';
import { Routes, Route } from 'react-router-dom';

/* Components ---------------------------*/
import Home from './pages/Home';
import Federal  from './pages/Federal';
import California  from "./pages/California";
import TaxCalculator from './pages/TaxCalculator';
import Additional from './pages/Additional';

const Routing = () => {
    return (
            <Routes>
                <Route element={ <Home /> }             path='/' />
                <Route element={ <Federal /> }          path='federal' />
                <Route element={ <California /> }       path='california' />
                <Route element={ <TaxCalculator /> }    path='tax-calculator' />
                <Route element={ <Additional /> }       path='additional' />
            </Routes>
    );
}

export default Routing;